import React from 'react';
import styled from 'styled-components';
import { Button } from 'antd';
import { useMutation } from '@apollo/react-hooks';
import { UPDATE_DEFAULT_PROFILE } from '@api/graphql/profile/applications';
import AccountTheme from '../../../context';

const Default = styled.span`
  display: inline-block;
  background-color: #E9F3FD;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 300;
  padding: 4px 10px;
  position: absolute;
  right: 15px;
  top: -4px;
`;

const Cell = styled.div`
  position: relative;
  font-weight: 300;
  width: 100%;
  box-sizing: border-box;
  white-space: nowrap;
  text-overflow: ellipsis;

  &:hover button{
    display: inline-block;
  }

  .name {
    display: inline-block;
  }

  button {
    position: absolute;
    right: 15px;
    top: -5px;
    display: none;
  }
`;

interface INameCellProps {
  profileId: number,
  name: string;
  primary: boolean;
}

const NameCell = ({
  profileId,
  name,
  primary,
}: INameCellProps) => {
  const { theme } = React.useContext(AccountTheme);
  const [updateDefaultProfile] = useMutation(UPDATE_DEFAULT_PROFILE);

  const makeDefault = React.useCallback(() => {
    updateDefaultProfile({
      variables: {
        profileId,
      },
    });
  }, [updateDefaultProfile]);

  return (
    <Cell>
      <span className="name">{name}</span>
      {primary && <Default>Default</Default>}
      {!primary && <Button type="primary" onClick={makeDefault}>Make Default</Button>}
    </Cell>
  );
};

export default NameCell;
